/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_DetailsInputs */

const en_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Details`)
};

const es_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles generales`)
};

const fr_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails généraux`)
};

const de_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Details`)
};

const ja_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般詳細`)
};

const zh_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般详情`)
};

const ar_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل عامة`)
};

const id_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Umum`)
};

const it_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli Generali`)
};

const ru_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие сведения`)
};

const pt_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes Gerais`)
};

const ko_general_details = /** @type {(inputs: General_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반 세부 정보`)
};

/**
* | output |
* | --- |
* | "General Details" |
*
* @param {General_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const general_details = /** @type {((inputs?: General_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_details(inputs)
	if (locale === "es") return es_general_details(inputs)
	if (locale === "fr") return fr_general_details(inputs)
	if (locale === "de") return de_general_details(inputs)
	if (locale === "ja") return ja_general_details(inputs)
	if (locale === "zh") return zh_general_details(inputs)
	if (locale === "ar") return ar_general_details(inputs)
	if (locale === "id") return id_general_details(inputs)
	if (locale === "it") return it_general_details(inputs)
	if (locale === "ru") return ru_general_details(inputs)
	if (locale === "pt") return pt_general_details(inputs)
	return ko_general_details(inputs)
});